import { useUI } from "../store";

// NCSA ships only a dark-ink logo, so both marks sit on a white plate in either theme.
// Do not use this on dark slide footers — the plate reads as a white bar every page.
export function OrganizerLockup({ variant = "full" }: { variant?: "full" | "compact" }) {
  const { language } = useUI();
  const alt = language === "th"
    ? { thnic: "มูลนิธิศูนย์สารสนเทศเครือข่ายไทย", ncsa: "สำนักงานคณะกรรมการการรักษาความมั่นคงปลอดภัยไซเบอร์แห่งชาติ" }
    : { thnic: "THNIC Foundation", ncsa: "National Cyber Security Agency" };
  const thnic = variant === "full"
    ? { src: "/assets/thnicf-wordmark.png", width: 1080, height: 288 }
    : { src: "/assets/thnicf-logo.png", width: 512, height: 512 };
  return <span className={`org-plate ${variant}`}>
    <img className="org-logo org-logo-thnic" src={thnic.src} alt={alt.thnic} width={thnic.width} height={thnic.height} />
    <span className="org-divider" aria-hidden="true" />
    <img className="org-logo org-logo-ncsa" src="/assets/ncsa-logo.png" alt={alt.ncsa} width={192} height={103} />
  </span>;
}
